import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileBulkDeleteMutationAtom = createMutationAtomFactory(
  'files.bulkDelete',
  ({ fileIds }: { fileIds: string[] }) => ({
    filesDeleteFiles: {
      __args: {
        fileIDs: fileIds,
      },
      succeeded: {
        fileId: true,
      },
      failed: {
        fileId: true,
        message: true,
      },
    },
  }),
);
